module.exports = __webpack_public_path__ + "img/todaypoints.433d11ad.png";